// Copy paste from https://github.com/catawiki/cw-assets/blob/master/app/assets/javascripts/partials/ab-tests.js
// Except for:
// * predefinedAbConditions.logged_in
// * predefinedAbConditions.logged_out
$(function() {
  var $window = $(window);
  var windowWidth = $window.width();
  var $tests = $('.js-ab-test[data-ab-key]');
  var $testsOutsideViewport = $tests.filter('[data-ab-only-when*="in_viewport"]');
  var breakpointMobile = 727;
  var breakpointDesktop = 996;
  var predefinedAbConditions = {
    logged_in: $('body').hasClass('cw_logged_in'),
    logged_out: !$('body').hasClass('cw_logged_in'),
    mobile_user: windowWidth < breakpointMobile,
    tablet_user: windowWidth >= breakpointMobile && windowWidth < breakpointDesktop,
    desktop_user: windowWidth >= breakpointDesktop,
    in_viewport: true,
  };

  if (typeof AB === 'undefined' || AB === null) {
    // When AB is not available always show A.
    $tests.addClass('show-a');
    return;
  }

  // Add class to each AB test based on
  // it's AB key and optinal conditions.
  // AB key should be set as data-attribute "ab-key".
  function doCoinFlip($els) {
    $els.each(function() {
      var $test = $(this);

      // Check if there is an AB key given, check optinal AB conditions
      // are all true and if the AB test is in B, if not it will set
      // the class name for the A variant.
      var variant = 'a';
      var key = $test.data('ab-key');
      if (checkConditions($test) && AB.test(key) === 'B') {
        variant = 'b';
      }

      $test.addClass('show-' + variant);
    });
  }

  function startTestsWhenInViewport() {
    var viewportTop = $window.scrollTop();
    var viewportBottom = viewportTop + $window.height();
    var startedExperiments = false;

    $testsOutsideViewport.each(function() {
      var $test = $(this);
      var testTop = $test.offset().top;
      var testBottom = testTop + $test.height();
      // If it's inside the viewport, start the test!
      if (testTop < viewportBottom && testBottom > viewportTop) {
        doCoinFlip($test);
        startedExperiments = true;
      }
    });

    // Remove started experiments from $testsOutsideViewport
    if (startedExperiments) {
      $testsOutsideViewport = $testsOutsideViewport.not('.show-a, .show-b');
    }

    // Check twice per second if there are still tests outside the viewport
    if ($testsOutsideViewport.length) {
      setTimeout(startTestsWhenInViewport, 500);
    }
  }

  doCoinFlip($tests.not($testsOutsideViewport));
  if ($testsOutsideViewport.length) {
    startTestsWhenInViewport();
  }

  // Delegate AB conversion to clicks.
  // Uses data-attribute "ab-goal" as conversion goal.
  $('body').on('click.ab-click-conversion', '.js-ab-click', function() {
    var goal = $(this).data('ab-goal');

    if (typeof goal !== 'undefined') {
      AB.conversion(goal);
    }
  });

  // By using the data-attribute "ab-only-when" you can easily give
  // predefined conditions for when the AB test should be triggered.
  // Predefined conditions should return a BOOLEAN [true/false].
  // All conditions must return true for the AB test to be triggered.
  function checkConditions(el) {
    var conditions = $(el).data('ab-only-when');

    if (typeof conditions === 'undefined') {
      // If there is no data-attribute set
      // the AB test can continue.
      return true;
    }

    // Map list of conditions to a list of true and false.
    var states = conditions.split(' ').map(function(condition) {
      return predefinedAbConditions[condition] || false;
    });

    // Return true if the states list doesn't contain a false.
    return (states.indexOf(false) === -1);
  }
});
